import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';
// types
import {
  ICategortItem,
  IProductItem,
  IProductsItem,
  IRoles,
  IRolesItemAll,
} from 'src/types/product';

export function useGetRoles() {
  const URL = `${endpoints.admin.rolesStatus}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      // data: (data?.data as ICategortItem[]) || [],
      roles: (data?.data as IRoles[]) || [],
      productsLoading: isLoading,
      total: (data?.total as number) || 0,
      productsError: error,
      productsValidating: isValidating,
      productsEmpty: !isLoading && !data?.data,
    }),
    [data?.data, data?.total, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export function useGetAdmin(page = 1) {
  // const URL = endpoints.test.category;
  const URL = `${endpoints.admin.getalladmin}?page=${page}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      // data: (data?.data as ICategortItem[]) || [],
      tabledataadmin: (data?.results.data as any) || [],
      productsLoading: isLoading,
      total: (data?.results.total as number) || 0,
      productsError: error,
      productsValidating: isValidating,
      productsEmpty: !isLoading && !data?.data,
    }),
    [data?.data, data?.results.data, data?.results.total, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export function useGetproducts(page = 1) {
  // const URL = endpoints.test.category;
  const URL = `${endpoints.products.getproduct}?page=${page}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      // data: (data?.data as ICategortI tem[]) || [],
      tabledataproducts: (data?.results as IProductsItem[]) || [],
      productsLoading: isLoading,
      total: (data?.total as number) || 0,
      productsError: error,
      productsValidating: isValidating,
      productsEmpty: !isLoading && !data?.results.length,
    }),
    [data?.results, data?.total, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetCategoryFilter(
  name: string[],
  startDate: Date | null,
  endDate: Date | null,
  top: string[],
  page = 1
) {
  function convert(dateString: any) {
    if (dateString != null) {
      const dates = dateString.toString();
      const parts = dates.split(' ');
      const datepart = parts.slice(0, 4).join(' ');
      const timepart = parts.slice(4).join(' ');
      const d = new Date(datepart);
      const timezone = timepart.match(/[+-]\d{4}/)[0];
      d.setMinutes(d.getMinutes() + parseInt(timezone, 10));
      const newdate = d.toISOString();
      return newdate;
    }
    return null;
  }
  const inputstartDate = startDate;
  const inputendDate = endDate;
  const startdate = convert(inputstartDate);
  const enddate = convert(inputendDate);
  const URL = `${endpoints.test.category}/?page=${page}&name=${name}&dates[]=${startdate}&dates[]=${enddate}&top=${top}`;
  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);
  const memoizedValue = useMemo(
    () => ({
      filterddata: (data?.data as ICategortItem[]) || [],
      productsLoading: isLoading,
      total: (data?.total as number) || 0,
      productsError: error,
      productsValidating: isValidating,
      productsEmpty: !isLoading && !data?.data.length,
    }),
    [data?.data, data?.total, error, isLoading, isValidating]
  );
  return memoizedValue;
}

// Advertisement========================================================================
